import MaterialLink, { LinkProps } from '@mui/material/Link';

interface Props extends LinkProps {
    disabled?: boolean;
}

export function Link(props: Props) {
    return <MaterialLink data-testid={'Link-container'} {...props} />;
}

export default Link;
